import { render, staticRenderFns } from "./Chapters.vue?vue&type=template&id=094952ab&scoped=true&"
import script from "./Chapters.vue?vue&type=script&lang=js&"
export * from "./Chapters.vue?vue&type=script&lang=js&"
import style0 from "./Chapters.vue?vue&type=style&index=0&id=094952ab&scoped=true&lang=css&"
import style1 from "./Chapters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094952ab",
  null
  
)

export default component.exports